import {STOCK_ROUTE} from 'core/modules/routing/constants';

export const getStockUrl = (code: string) => {
    return `${STOCK_ROUTE}/${code}`;
};
